import { isWeb } from "../utils/utils";
import api_comm from "./lib";

async function disputeClaim(claim, productclaim_guid, session_token) {
	let base64 = claim.attachment_proof_of_sale?.uri?.split(",")[1];

	let File = isWeb() ? base64 : claim.attachment_proof_of_sale?.uri;

	let params = {
		account_details: {
			id_passport: claim.ID,
		},
		claim: {
			transaction_date: claim.transaction_date,
			store_guid: claim.store_guid,
			storemember_guid: claim.storemember_guid,
		},
		attachment: {
			attachment_proof_of_sale: File,
		},
	};

	return api_comm(
		"post",
		`/claims/api/v2/claim/dispute/${productclaim_guid}`,
		params,
		session_token
	);
}

export default disputeClaim;
